import parseYamlFile from 'app/components/analytics-builder/export-import/parseYamlFile';
import validateSettings from './validateSettings';
import validateSettingsPartial from './validateSettingsPartial';
import UPDATE_MODES from 'app/components/analytics-builder/export-import/UPDATE_MODES';
import filterUploadedSettings from 'app/components/analytics-builder/export-import/upload/filterUploadedSettings';

/**
 * Parse and validate uploaded YAML content
 *
 * @param {object} params - Parameters
 * @param {string} params.fileContent - Raw YAML file content
 * @param {string} params.updateMode - Update mode (override or merge)
 * @returns {object} { success: boolean, data: object, errors: string[] }
 */
export default function parseAndValidateUpload({ fileContent, updateMode }) {
  try {
    const parsedData = parseYamlFile(fileContent);
    const filteredSettings = filterUploadedSettings(parsedData);

    const validateFn = updateMode === UPDATE_MODES.MERGE ? validateSettingsPartial : validateSettings;
    const validation = validateFn(filteredSettings);

    if (!validation.isValid) {
      return { success: false, data: null, errors: validation.errors };
    }

    return { success: true, data: filteredSettings, errors: [] };
  } catch (error) {
    return { success: false, data: null, errors: [error.message] };
  }
}
